<template>
              <v-list-item style="height: 32px;min-height: 20px">
                                <v-list-item-content class="my-0 py-0">
                                  <v-list-item-title  class="my-0 py-0">
                                        <v-text-field 
                                              v-model="searchText"
                                              auto-grow
                                              rows= 1
                                              hide-details
                                              ref="addNew"
                                              :placeholder="isMain ? 'Zoek, Voeg een vraag toe of plak een lijst.....' : 'Zoek een vraag of voeg eentje toe ..'"
                                              
                                              @paste="paste"
                                              @keydown.enter="add"
                                              color="indigo--text lighten-3"
                                              class="minimal body-2 border-less indigo--text lighten-3 my-0 py-0"
                                              
                                            >
                                                    
                                    </v-text-field>
                                  </v-list-item-title>
                                  </v-list-item-content>
                                  <v-list-item-action v-if="false">
                                      <v-icon color="grey" @click="add">add</v-icon>
                                  </v-list-item-action>
                              </v-list-item>   

</template>
<script>
import {
  mapState, mapMutations, mapActions, mapGetters
} from 'vuex'

export default {
  props: ['isMain', 'loading', 'transparent'],
   data: () => ({
    all: false,
    input: '',
    selectedTemplates: []
  }),
  computed: {
     ...mapGetters('auth', ["Role","maincontact"]),
     ...mapState('auth', ["settings"]),
    ...mapState('app', ["template"]),
    ...mapState('match', ["selected","templates"]),
    ...mapGetters('match', ["search"]),
    selectedTemplatessss: {
      get() {
          return this.selected.questions.map(q => q.title) 
      },
      set(value) {
        console.log(value)
      }
    },
    searchText: {
            get() {
                 return this.search
            },
            set(value) {
                this.setSearch(value)
            }
      },
    questions () {
        var self = this, qs = this.templates
        if (self.search && self.search.length > 0) {
            qs = qs.filter(q => q.title.toUpperCase().indexOf(self.search.toUpperCase()) > -1 || q.linkto.indexOf(self.search.toLowerCase()) > -1)
        } else {
         qs = this.templates.filter(
            q => self.selected.questions.filter(t => t.title == q.title).length==0
            && q.linkto.filter(value => self.tags.includes(value)).length > 0
            && !self.tags.includes(q.tag)
            && !self.tags.includes(q.notag)
            )
        }
        if (this.Role('admin') && this.isMain || this.all) qs =  this.templates.filter(
            q => self.selected.questions.filter(t => t.title == q.title).length==0)
        return qs
      },
      count () {
        return this.questions.length
      },
        tags () {
        var tags = []
         //
        var tags = this.settings.tags.map(t => t.tag) //.filter(q=> q.type=='branche' || q.type=='category')
        if (this.selected.tags) tags = this.selected.tags.map(t => t.tag) //.filter(q=> q.type=='branche' || q.type=='category')
        if (this.selected.tags) this.selected.tags.filter(q=> q.type=='category' || q.type=='type').map(t => {
            tags.push(t.path.replaceAll(' / ', '###').split('/')[0].replaceAll('###',' / '))
        })
        return tags
      }
  },
  watch: {
    /*tags (value, oldValue){  
        var self = this
        if (oldValue.length > 0 && value.length>0) {
            this.templates.filter(q=> q.linkto.indexOf(value[value.length-1])>-1).forEach(function(question){
                   //setTimeout(function(){
                    self.addQuestion(question) 
                   //},3000)
            })
        }
    }*/
  },
  mounted (){
      var self = this

  },
  methods: {
      ...mapMutations('app', ["setTemplate","setChat"]),
     ...mapActions('match', ["addQuestion","addAnswer"]),
     ...mapMutations('match', ["setSearch"]),
     focusMe () {
         var self = this
       setTimeout(() => {
            if (self.$refs.search) self.$refs.search.focus()          
        },500)
       
     },
     paste (evt) {
          var self = this
          setTimeout(function(){
            self.search.split(/\r?\n/).forEach(function(q){
                self.addItem(q)
            })
            self.search = null
            self.$refs.addNew.focus()
          },100)
          return true
      } ,
     addTemplates(){
         var self = this
         this.selectedTemplates.map(t => self.addTemplateItem(self.questions.filter(item => item.title == t)[0]))
         this.selectedTemplates = []
     },
     menu () {
       this.$emit('menu')  
     },
     add (t) {
        this.addItem(this.search)
        this.searchText = ''
      },
       addItem (c, keep) {
          if (!c) return false
          c = c.trim()
          if (c == '') return false
         const time = (new Date()).toTimeString()
         var q = {
          title: c,
          time: new Date(),
          type: "radio",
          score: 0,
           options: ['JA','NEE']
        }
        this.addQuestion(q)
        this.$emit('add',q)
      },
      addTemplateItem(q) {
            if (!q) return false
            var col = -1
            if (this.tags.includes(q.tag)) col = 0
            if (this.tags.includes(q.notag)) col = 1
            //if (col == -1 ) return false
            if (q.options) q.value = q.options[col]
            this.addQuestion(q)
        
            var a = { 
                    date: new Date(),
                    options: [],
                    owner: {email: this.maincontact.email, name: this.maincontact.name}, 
                    question: q.title,
                    score: 2}
            if (q.options) a.options.push(q.options[col])
            this.addAnswer(a)
    }
  }
}
</script>